import { WidgetType, WidgetFooterType, WidgetHeaderType } from '../widget.types';
import { Resource } from '@topconagriculture/permissions';
export const StatusWidgetConfig = {
    type: WidgetType.STATUS,
    single: true,
    thumbnail: '/assets/images/dashboard/widget-catalog/status.jpg',
    title: 'widget:status:title',
    description: 'widget:tasks:description',
    permissions: [Resource.FLEET],
    header: {
        type: WidgetHeaderType.GENERIC,
    },
    footer: (config) => ({
        type: WidgetFooterType.VIEW_MORE,
        href: config.MACHINE_STATUS_VIEW_MORE_LINK,
        text: 'widget:generic:footer_text',
    }),
    baseConfig: {
        type: WidgetType.STATUS,
        w: 1,
        h: 2,
        x: 0,
        y: 0,
    },
};
//# sourceMappingURL=StatusWidgetConfig.js.map